<template>
    <div v-if="candidate" @click="goTalent" class="talentItem">
        <div class="top">
            <div class="img-wrap">
                <img v-if="candidate.gender == 2" :src="candidate.avatar.remoteUrl | avatar('women')" v-img-error-user="2" alt="" />
                <img v-else :src="candidate.avatar.remoteUrl | avatar('men')" v-img-error-user="1" alt="" />
            </div>
            <div class="info">
                <p>
                    <span class="title van-ellipsis">{{candidate.candidateName || '未填写'}}</span>
                    <span class="salary">{{candidate.currentSalary*candidate.currentSalaryMonths | tenThousand}}元</span>
                </p>
                <div>
                    <div class="separate-info-list">
                        <span v-if="candidate.gender">{{candidate.gender | gender}}</span>
                        <span v-if="candidate.birthDate">{{candidate.birthDate | userAge}}岁</span>
                        <span v-if="candidate.workYear">{{candidate.workYear}}年</span>
                        <span v-if="candidate.cityId">{{candidate.cityId | city}}</span>
                    </div>
                    <span class="time" v-if="candidate.activeUserTimeDesc">{{candidate.activeUserTimeDesc}}更新</span>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="separate-info-list">
                <span v-if="candidate.profession">{{candidate.profession}}</span>
                <span v-if="candidate.school">{{candidate.school}}</span>
                <span v-if="candidate.degreeId">{{candidate.degreeId | degree}}</span>
            </div>
            <div class="separate-info-list">
                <span v-if="candidate.jobTitle">{{candidate.jobTitle}}</span>
                <span v-if="candidate.companyName">{{candidate.companyName}}</span>
            </div>
            <div v-if="talentTags" class="tag-list flex-box">
                <span class="tag" v-if="talentTags.famousCompany">名企</span>
                <span class="tag" v-if="talentTags.networkCompany">知名互联网</span>
                <span class="tag" v-if="talentTags.worldTop500">世界500强</span>
                <span class="tag" v-if="talentTags.is985">985</span>
                <span class="tag" v-if="talentTags.is211">211</span>
            </div>
        </div>
    </div>
</template>

<script>
import defaultAvatarBoy from "@/assets/default/boy40.png";
import defaultAvatarGirl from "@/assets/default/girl40.png";
export default {
  name: "talentItem",
  props: {
    talentTags: {},
    candidate: {
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      defaultAvatarBoy: defaultAvatarBoy,
      defaultAvatarGirl: defaultAvatarGirl
    };
  },
  components: {},
  methods: {
    goTalent() {
      this.$router.push({
        path: "/resume/candidateDetail/" + this.candidate.candidateId
      });
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.btn-color-wrap {
  float: right;
}
.talentItem {
  padding: 15px;
  background: #fff;
  margin-bottom: 10px;
  .separate-info-list {
    font-size: 13px;
  }

  .top {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 0.5px solid #e5e5e5;
    display: flex;

    .info {
      flex: 1;
      .time {
        font-size: 12px;
        color: #999999;
        line-height: 20px;
        float: right;
      }

      p {
        line-height: 20px;
        margin-bottom: 10px;
        font-size: 12px;
        color: #666666;
        .title {
          font-size: 16px;
          color: #333333;
          max-width: 200px;
        }

        .salary {
          margin-left: 15px;
          font-size: 14px;
        }
      }
    }
  }

  .bottom {
    width: 100%;
    overflow: hidden;
    .separate-info-list {
      margin-bottom: 10px;
      float: none;
    }
    .tag-list {
      .tag {
        height: 17px;
        line-height: 17px;
      }
    }
  }
  .stars-wrap {
    flex: 1;
  }
  .data-wrap {
    margin-left: auto;
    display: flex;
    .data-list {
      margin-left: 20px;
      white-space: nowrap;
    }
  }
}
</style>